export const DEFAULT_ATTRS = {
    xmlns: 'http://www.w3.org/2000/svg',
    role: 'presentation',
    focusable: false,
    fill: 'currentColor',
};

export const REACTIVE_NATIVE_ATTRS = {
    width: 50,
    height: 50,
    fill: 'orange',
};

export default DEFAULT_ATTRS;
